import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getEquipmentPreCheckAns({
  equipmentId,
  page,
  perPage,
  userId,
  sortBy,
  sortType,
  startAt,
  endAt,
}) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api/equipment-precheck-ans?`;
  url += getQueryParamsString({
    equipmentId,
    page,
    perPage,
    userId,
    sortBy,
    sortType,
    startAt,
    endAt,
  });

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function createEquipmentPreCheckAns(equipmentAns) {
  let url = `${BASE_URL}/api/equipment-precheck-ans`;

  const res = await axiosInstance.post(url, equipmentAns)
  return res.data.Data;
}

export async function updateEquipmentPreCheckAns(equipmentAns) {
  let url = `${BASE_URL}/api/equipment-precheck-ans`;
  const res = await axiosInstance.put(url)
  return res.data.Data;
}

export async function deleteEquipmentPreCheckAns(ansId) {
  let url = `${BASE_URL}/api/equipment-precheck-ans/${ansId}`;
  const res = await axiosInstance.delete(url)
  return res.data.Data;
}
